import React from 'react';
import './ClearAllDraftsModal.scss';

interface ClearAllDraftsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ClearAllDraftsModal: React.FC<ClearAllDraftsModalProps> = ({
  isOpen,
  onClose,
  onConfirm
}) => {
  if (!isOpen) return null;

  return (
    <div className="clear-all-drafts-modal-overlay">
      <dialog
        className="clear-all-drafts-modal"
        aria-modal="true"
        aria-labelledby="clear-all-drafts-modal-title"
      >
        <button
          className="clear-all-drafts-modal__close-button"
          onClick={onClose}
          aria-label="Close clear all drafts modal"
        >
          ✕
        </button>
        <div className="clear-all-drafts-modal__header">
          <h2 id="clear-all-drafts-modal-title" className="clear-all-drafts-modal__title">
            Are you sure you want to clear all drafts?
          </h2>
        </div>
        
        <div className="clear-all-drafts-modal__content">
          <p className="clear-all-drafts-modal__message">
            This action cannot be undone.
          </p>
        </div>
        
        <div className="clear-all-drafts-modal__footer">
          <div className="clear-all-drafts-modal__footer-container">
            <div className="clear-all-drafts-modal__footer-buttons">
              <auro-button
                className="clear-all-drafts-modal__cancel-button"
                onClick={onClose}
                aria-label="Cancel clear all drafts"
                variant='secondary'
                size='md'
              >
                No, cancel
              </auro-button>
              <auro-button
                className="clear-all-drafts-modal__clear-all-button"
                onClick={onConfirm}
                aria-label="Confirm clear all drafts"
                variant='primary'
                size='md'
              >
                Yes, clear all
              </auro-button>
            </div>
          </div>
        </div>
      </dialog>
    </div>
  );
};

export default ClearAllDraftsModal;